export const isFloat = (number: string) => /^[+-]?\d+(\.\d+)?$/.test(number);

export const toFixedPercentage = (perc: number): number => {
  if (perc <= 0) {
    return 0;
  }
  if (perc >= 100) {
    return 100;
  }
  const fixed = perc.toFixed(2).replace('.00', '');
  return isFloat(fixed) ? parseFloat(fixed) : parseInt(fixed);
};